import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

const getJourneyFrontendBootAPI = ({
  journeyId,
  signal,
}: {
  journeyId: string;
  signal?: AbortSignal;
}) =>
  handleGlobalGetRequestQuery({
    url: `/journeys/${journeyId}${URLS.FRONTEND_BOOT}`,
    signal,
  });

export { getJourneyFrontendBootAPI };
